import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-edit-ratio',
  templateUrl: './dialog-edit-ratio.component.html',
  styleUrls: ['./dialog-edit-ratio.component.scss']
})
export class DialogEditRatioComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogEditRatioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
